import React, { useRef } from 'react';

// tools
import uniqid from '../../../../helpers/uniqid';

const ButtonIconRadio = ({ children, onChange, checked, isSquare = false, color = '' }) => {
    const uuid = useRef(uniqid());
    const classes = ['appButton__iconRadioFlat']

    if (isSquare) {
        classes.push('appButton__icon--square')
    }

    const style = color ? { '--active-color': color } : undefined;

    return(
        <label htmlFor={uuid.current} className={classes.join(' ')} style={style}>
            <input type="checkbox" id={uuid.current} onChange={onChange} checked={checked}/>
            {children}
        </label>
    )
}

export default ButtonIconRadio;